var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEqtRealEstate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 40,
    viewBox: "0 0 136 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_2039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.025 1.0177H99.601V7.54926H136.025V1.0177Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2424 1.0177H13.3656V7.54926H36.2424V1.0177Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2424 16.6722H13.3656V23.2038H36.2424V16.6722Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2424 32.4493H13.3656V38.9809H36.2424V32.4493Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46418 1.0177H0V38.9795H6.46418V1.0177Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.033 14.5671H114.569V39.0026H121.033V14.5671Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8908 19.9884C56.8908 12.5536 62.8736 6.53156 70.2088 6.53156C77.5441 6.53156 83.5269 12.5767 83.5269 19.9884C83.5269 19.9884 83.5269 20.0347 83.5269 20.0579H89.991V19.9884C89.991 8.94036 81.12 0 70.2088 0C59.2976 0 50.4266 8.96352 50.4266 19.9884C50.4266 31.0133 59.2518 39.9537 70.14 39.9768V33.4453C62.8277 33.399 56.8908 27.377 56.8908 19.9884Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6165 19.0006L69.0456 23.6191L84.8654 39.6038L89.4362 34.9853L73.6165 19.0006Z",
    fill: "#FF6600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_2039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqtRealEstate);
export default __webpack_public_path__ + "static/media/eqt-real-estate.81fdd27a06657ae5f41bc0c7b7774e2f.svg";
export { ForwardRef as ReactComponent };